import * as React from 'react';
import { useCallback } from 'react';

import { useSlate, useSlateStatic } from 'slate-react';

import { SuperscriptIcon } from '@coursera/cds-icons';

import Button, { TOOLBAR_BUTTON_TYPES } from 'bundles/cml/editor/components/buttons/Button';
import { isTypeDisabled } from 'bundles/cml/editor/utils/elementUtils';
import { isMarkActive, toggleMark } from 'bundles/cml/editor/utils/markUtils';
import { getToolBarShortcutKey } from 'bundles/cml/editor/utils/toolbarUtils';
import { MARKS } from 'bundles/cml/shared/constants';

import _t from 'i18n!nls/cml';

const SuperscriptButton = () => {
  const editor = useSlate();
  const staticEditor = useSlateStatic();
  const disabled = isTypeDisabled(editor, MARKS.SUPERSCRIPT);
  const active = isMarkActive(editor, MARKS.SUPERSCRIPT);

  const handleClick = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    () => toggleMark(staticEditor, MARKS.SUPERSCRIPT),
    [staticEditor]
  );

  const shortcutKey = getToolBarShortcutKey('.');
  return (
    <Button
      onClick={handleClick}
      disabled={disabled}
      active={active}
      className="rc-SuperscriptButton"
      title={_t('Superscript #{shortcutKey}', { shortcutKey })}
      aria-label={_t('Superscript #{shortcutKey}', { shortcutKey: getToolBarShortcutKey('period') })}
      type={TOOLBAR_BUTTON_TYPES.formatting}
    >
      <SuperscriptIcon size="small" />
    </Button>
  );
};

export default SuperscriptButton;
